import { MutableRefObject, useEffect, useRef } from "react";

export function useDidUpdate(callback: Function, observables: any[]): void {
  const isMounted: MutableRefObject<boolean> = useRef<boolean>(false);

  if (!Array.isArray(observables)) {
    throw new Error("[useDidUpdate]: Second argument should be an array");
  }

  if (!observables.length) {
    throw new Error(
      "[useDidUpdate]: The second argument should include observable variables"
    );
  }

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    return callback();
  }, observables);
}
